import React, { useState } from "react";
import PlansPaymentComponent from "../../../plans/plansPayment";
import { IoIosArrowRoundBack } from "react-icons/io";
import WarningModal from "../WarningModal/WarningModal";
import { EnterprisePlans } from "./plans/EnterprisePlans";
import { StudioPlans } from "./plans/StudioPlans";
import { StudentPlans } from "./plans/StudentPlans";
import { StudentFreePlans } from "./plans/StudentFreePlans";
import { CoachPlans } from "./plans/CoachPlans";
import { userService } from "../../../../services/user";
import { toast } from "react-toastify";
import { listOfSubscriptions } from "../../../../common/envConfig";
import WarningModalForExpired from "../WarningModal/WarningModalForExpired";

export const AccountDetailsPlanChoice = ({
  onViewChange,
  type,
  currentPlan,
  email,
  userId,
  subscriptionData,
  fullName,
  onSubscriptionPurchase,
}) => {
  const [isPurchaseView, setIsPurchaseView] = useState(false);
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isConfirmModalForExpriredOpen, setConfirmModalForExpiredOpen] =
    useState(false);

  const [selectedPlan, setSelectedPlan] = useState(null);
  const [addOn, setAddOn] = useState(false);

  const typeSwitch = () => {
    switch (type) {
      case "Enterprise":
        return (
          <EnterprisePlans
            currentPlan={
              subscriptionData?.endDate > Date.now() ? currentPlan : ""
            }
          />
        );
      case "Studio":
        return (
          <StudioPlans
            currentPlan={
              subscriptionData?.endDate > Date.now() ? currentPlan : ""
            }
          />
        );
      case "Student":
        return (
          <StudentPlans
            currentPlan={
              subscriptionData?.endDate < Date.now() ||
              subscriptionData?.platform !== "Stripe"
                ? ""
                : currentPlan
            }
            onGetStarted={handleGetStartedClick}
          />
        );
      case "Free":
        return (
          <StudentFreePlans
            currentPlan={currentPlan}
            onGetStarted={handleGetStartedClick}
          />
        );
      default:
        return (
          <CoachPlans
            currentPlan={
              subscriptionData?.endDate < Date.now() ||
              subscriptionData?.platform !== "Stripe"
                ? ""
                : currentPlan
            }
            onGetStarted={handleGetStartedClick}
          />
        );
    }
  };

  const handleGetStartedClick = async (selectedPlan, addOn) => {
    try {
      setSelectedPlan(selectedPlan);
      setAddOn(addOn);

      if (selectedPlan === listOfSubscriptions.STUDENT_FREE) {
        await userService.updateUserNY({
          subscriptionType: listOfSubscriptions.STUDENT_FREE,
          uid: userId,
          role: "",
        });

        toast.success("Successfully updated to Free plan");
        window.location.reload();
        return;
      }
      if (
        subscriptionData &&
        (subscriptionData.autoRenewal || subscriptionData.endDate > Date.now())
      ) {
        setConfirmModalOpen(true);
      } else {
        setConfirmModalForExpiredOpen(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleConfirm = async () => {
    try {
      // await userService.cancelCurrentSubscription(email);
    } catch (err) {
      console.error(err);
    } finally {
      setConfirmModalOpen(false);
      setIsPurchaseView(true);
    }
  };

  return (
    <>
      {isPurchaseView ? (
        <PlansPaymentComponent
          productId={selectedPlan}
          bootcampUser={false}
          email={email}
          uid={userId}
          finish={() => window.location.reload()}
          back={() => onSubscriptionPurchase(false)}
          subData={subscriptionData}
          fullName={fullName}
          addOn={addOn}
        />
      ) : (
        <div className="p-4 lg:p-6 rounded-xl border border-gray200 shadow-[0_1px_3px_0_rgba(14,24,41,0.10),_0_1px_2px_0_rgba(14,24,41,0.06)]">
          <div
            onClick={onViewChange}
            className="flex items-center gap-2 mb-6 cursor-pointer w-fit"
          >
            <IoIosArrowRoundBack className="size-6 min-w-6 text-gray600" />
            <div className="text-gray600 font-semibold text-sm">Back</div>
          </div>
          {typeSwitch()}

          <WarningModal
            isOpen={isConfirmModalOpen}
            subscriptionData={subscriptionData}
            addOn={addOn}
            selectedPlan={selectedPlan}
            onConfirm={handleConfirm}
            onCancel={() => setConfirmModalOpen(false)}
          />

          <WarningModalForExpired
            isOpen={isConfirmModalForExpriredOpen}
            addOn={addOn}
            selectedPlan={selectedPlan}
            onConfirm={handleConfirm}
            onCancel={() => setConfirmModalForExpiredOpen(false)}
          />
        </div>
      )}
    </>
  );
};
